import getData from "./getData";

const baseUrl = process.env.BASE_URL;

/**
 * Extracts and returns the first element in the 'data' array if it exists in the 'result' object.
 * If 'data' array is empty, returns the 'data' array.
 * If 'data' doesn't exist, returns the 'result' object.
 *
 * @param {Object} result - the input object containing data to extract
 * @return {any} the extracted data based on the rules described
 */
const extractData = (result) => {
  if (result?.data?.length) return result.data[0];
  return result?.data || result;
};

export default async function ({
  page,
  query,
  parent,
  url,
  defaultValues = {},
}) {
  const result = page
    ? await getData(
        page,
        `populate[meta][populate][0]=image&${query}`,
        defaultValues
      )
    : defaultValues;

  const { meta = {} } = extractData(result);

  const metaImages = [];
  if (meta?.image && meta?.image?.url) {
    metaImages.push(meta?.image.url);
  }
  const previousImages = (await parent)?.openGraph?.images || [];

  /** @type {import('next').Metadata} */
  const metadata = {
    metadataBase: baseUrl,
    ...meta,
    openGraph: {
      images: [...metaImages, ...previousImages].filter(Boolean),
      type: "website",
      url,
    },
    alternates: {
      canonical: `${baseUrl}${url}`,
    },
  };

  return metadata;
};
